export const avatars = [
  "https://www.svgrepo.com/show/26995/avatar.svg",
  "https://www.svgrepo.com/show/8137/avatar.svg",
  "https://www.svgrepo.com/show/26474/avatar.svg",
  "https://www.svgrepo.com/show/26325/avatar.svg",
  "https://www.svgrepo.com/show/27220/avatar.svg",
];
